import axios from 'axios'

const instance = axios.create({
    // baseURL: 'http://prime.adminez.co.kr',
    baseURL: '/',
    timeout: 54000,
})

export default instance
